import { faTrash } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import Modal from 'src/components/theme/Models/Modal'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { lookupOptionsDocument, useMutateDeleteLookupOption } from 'src/queries'

interface DeleteConfirmationProps {
  id: string
  isOpen: boolean
  lookupId: string
  text: string
  toggle: () => void
  onDelete?: () => void
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = (props) => {
  const {
    id,
    isOpen,
    lookupId,
    text,
    toggle,
    onDelete
  } = props
  const mutateDelete = useMutateDeleteLookupOption()
  const invalidateOptions = useInvalidateQueryByDocument(lookupOptionsDocument)
  const handleDelete = (): void => {
    mutateDelete.mutate({
      id,
      key: lookupId
    }, {
      onSuccess: () => {
        toggle()
        if (typeof onDelete === 'function') {
          onDelete()
        }
        void invalidateOptions({ key: lookupId })
      }
    })
  }

  const isLoading = false // ToDo: Replace with actual loading state

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      title='Delete Confirmation'
      error={{
        error: 'There was an error deleting this option.',
        details: mutateDelete.error instanceof Error ? mutateDelete.error.message : '',
        show: mutateDelete.isError
      }}
      action={{
        text: 'Delete',
        onAction: handleDelete,
        disabled: isLoading,
        color: 'danger',
        icon: faTrash
      }}
    >
      <div className='text-center'>
        <p>Are you sure you want to delete <b>{text}</b> option?</p>
      </div>
    </Modal>
  )
}

export default DeleteConfirmation
